import { render, staticRenderFns } from "./ContentEventSelect.vue?vue&type=template&id=f456ab5e&"
import script from "./ContentEventSelect.vue?vue&type=script&lang=js&"
export * from "./ContentEventSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports